export type BsPromiseIconId = 'refund' | 'exchange' | 'certified' | 'exclusive';

export interface BsPromiseGridItem {
  id: BsPromiseIconId;
  titleLines: string[];
  descriptionLines: string[];
  analyticsLabel: string;
}

export interface BsPromiseDetailItem {
  id: BsPromiseIconId;
  title: string;
  subtitle?: string;
  paragraphs?: string[];
  listItems?: string[];
}

export const BS_PROMISE_GRID_ITEMS: BsPromiseGridItem[] = [
  {
    id: 'refund',
    titleLines: ['100%', 'Refund'],
    descriptionLines: ['Return within 30 Days', 'of Delivery'],
    analyticsLabel: 'Refund',
  },
  {
    id: 'exchange',
    titleLines: ['Lifetime Exchange', '& Buyback'],
    descriptionLines: ['Exchange for current', 'value or get Cash'],
    analyticsLabel: 'Exchange',
  },
  {
    id: 'certified',
    titleLines: ['100% Certified', 'Jewellery'],
    descriptionLines: ['BIS Hallmark, IGI,', 'GIA, HKD'],
    analyticsLabel: '100% Certified',
  },
  {
    id: 'exclusive',
    titleLines: ['Exclusive', 'Designs'],
    descriptionLines: ['6000+ Designs by', 'award winning designers'],
    analyticsLabel: 'Exclusive designs',
  },
];

export const BS_PROMISE_DETAIL_ITEMS: BsPromiseDetailItem[] = [
  {
    id: 'refund',
    title: '100% Refund',
    subtitle: 'Return within 30 Days of Delivery',
    paragraphs: [
      'You can return the product within 30 days from the date of delivery if you are not satisfied with the product or if it doesn’t fit you. Your return shipping charges are free and you get 100% refund to your bank account or you may choose to make another purchase.',
    ],
  },
  {
    id: 'exchange',
    title: 'Lifetime Exchange & Buyback',
    subtitle: 'Exchange for current value or get Cash',
    paragraphs: [
      'The product purchased on BlueStone can be exchanged on BlueStone anytime if you don’t need it anymore. Its value will be determined based on product specifications and the current price listed on our website with deductions towards making charges. This value can be used to buy any other product on BlueStone.',
    ],
  },
  {
    id: 'certified',
    title: '100% Certified Jewellery',
    paragraphs: ['Every piece you get is fully checked for quality and authenticity by reputed agencies:'],
    listItems: [
      'GOLD certified with BIS Hallmark.',
      'DIAMOND certificate of authenticity from IGI and HKD.',
      'SOLITAIRES carry a certificate of authenticity from GIA and IGI.',
    ],
  },
  {
    id: 'exclusive',
    title: 'Exclusive Designs',
    subtitle: '6000+ Designs by award winning designers',
    paragraphs: [
      'Our in-house award-winning design team pays great attention to detail to make each piece a symbol of perfection. Our designs are stylish, modern and contemporary and we have a design to suit every mood, budget and occasion.',
    ],
  },
];
